'use client';

import { PropsWithChildren } from 'react';

import Link, { useLinkStatus } from 'next/link';

interface IProps {
  href: string;
  className?: string;
}

// Must render as a child of <Link> — useLinkStatus reads the nearest Link's
// pending navigation state, it cannot be called from the Link's own component.
const LinkPendingOverlay = () => {
  const { pending } = useLinkStatus();

  if (!pending) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-10 animate-pulse rounded-xl bg-black/10 dark:bg-white/10" />
  );
};

export const StoryTileLink = ({
  href,
  className,
  children,
}: PropsWithChildren<IProps>) => (
  <Link href={href} className={className}>
    {children}
    <LinkPendingOverlay />
  </Link>
);
